module.exports = __webpack_public_path__ + "img/amex.04a06688.jpg";